// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3zcSf","footer":"ModalUpdate_footer__zHimE"};